import { Routes } from '@angular/router';

import { AcompanhamentoComponent } from './acompanhamento.component';
import { InscricoesComponent } from './inscricoes/inscricoes.component';

export const ACOMPANHAMENTO_ROUTER: Routes = [
  {
    path: 'acompanhamento',
    component: AcompanhamentoComponent,
    data: {
      meta: {
        title: 'Pós-Graduação no Ceuma',
        description: 'Pós-Graduação - 2º via de boleto de inscrição',
      },
    },
  },
  {
    path: 'inscricoes',
    component: InscricoesComponent,
    data: {
      meta: {
        title: 'Pós-Graduação - 2º via de boleto',
        description: 'Pós-Graduação - 2º via de boleto',
      },
    },
  },
];
